import { ButtonLink } from "@/components/ButtonLink/ButtonLink";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

export function PlaygroundButtonLink() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Basic Usage</PlaygroundSubSectionTitle>
        <p className="text-xs font-normal text-muted-foreground">
          Mint call-to-action rendered as an anchor. Clicking follows the href.
        </p>
        <div className="flex flex-wrap items-center gap-4">
          <ButtonLink href="https://aircall.io" target="_blank">
            Discover Aircall
          </ButtonLink>
        </div>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Same tab</PlaygroundSubSectionTitle>
        <p className="text-xs font-normal text-muted-foreground">
          Default target opens the link in the current tab.
        </p>
        <div className="flex flex-wrap items-center gap-4">
          <ButtonLink href="#basic">Go to section</ButtonLink>
        </div>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Long label</PlaygroundSubSectionTitle>
        <p className="text-xs font-normal text-muted-foreground">
          The label never wraps; the button grows to fit its content.
        </p>
        <div className="flex flex-wrap items-center gap-4">
          <ButtonLink href="#long" target="_blank">
            Explore everything Aircall can do for your team
          </ButtonLink>
        </div>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
